// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1__kq","cls2":"FullScreenPremiumModal-cls2_a1A FullScreenPremiumModal-cls1__kq"};